import { render, staticRenderFns } from "./TenantLogo.vue?vue&type=template&id=7bec61be"
import script from "./TenantLogo.vue?vue&type=script&lang=js"
export * from "./TenantLogo.vue?vue&type=script&lang=js"
import style0 from "./TenantLogo.vue?vue&type=style&index=0&id=7bec61be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports